import React, { useEffect, useState, useContext } from 'react';
import { Form, Button, Row, Col, Upload, message, Menu, Dropdown, Select } from 'antd';
import { LoadingOutlined, PlusOutlined, DownOutlined, UserOutlined } from '@ant-design/icons';
import { URL } from '../../../config/api';
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');

const ModalBody = ({close, handleSubmit, sticker, update, categories}) => {
    if(!categories) {
        categories = [];
    }

    var newCategories = [];
    categories.forEach((item, index) => {
        var newCategory = {label: item.Name, value: item.Id};
        newCategories.push(newCategory);
    });
          
    const [categoryName, setCategoryName] = useState('Select Category');
    const [categoryId, setCategoryId] = useState(0);
    const [name, setName] = useState('');
    const [tags, setTags] = useState('');
    const [loading, setLoading] = useState(false);
    const [imageUrl, setImageUrl] = useState('');
    const [realImageUrl, setRealImageUrl] = useState('');

    const [svgUrl, setSvgUrl] = useState('');
    const [realSvgUrl, setRealSvgUrl] = useState('');

    const [form] = Form.useForm();
    const uploadButton = (
      <div>
        {loading ? <LoadingOutlined /> : <PlusOutlined />}
        <div style={{ marginTop: 8 }}>Upload</div>
      </div>
    );

    useEffect(() => {
        if(!sticker){
            setCategoryName("Select Category");
            setCategoryId(0);
            setName("");
            setTags("");
            setImageUrl("");
            setRealImageUrl("");
            setSvgUrl("");
            setRealSvgUrl("");
            form.setFieldsValue({
                name: "",
                tags: ""
            })
            
            return;
        }

        console.log("STICKER", sticker);
        setCategoryName(sticker.CategoryName);
        setCategoryId(sticker.CategoryId);
        setName(sticker.ImageName);
        setImageUrl(sticker.ImageUrl);
        setRealImageUrl("");
        if(sticker.Tag) {
            setTags(sticker.Tag);
            form.setFieldsValue({
                name: sticker.ImageName,
                tags: sticker.Tag
            })
        } else {
            setTags("");
            form.setFieldsValue({
                name: sticker.ImageName,
                tags: ""
            })
        }

        if(sticker.SvgUrl) {
            setSvgUrl(sticker.SvgUrl);
        } else {
            setSvgUrl("");
        }
        setRealSvgUrl("");
    }, [update])

    const onFinish = (values) => {
        handleSubmit({
            categoryId: categoryId,
            name: name,
            imageUrl: realImageUrl,
            svgUrl: realSvgUrl,
            tags: tags
        })
    }

    function beforeUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
            message.error('You can only upload JPG/PNG file!');
        }
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isLt2M) {
            message.error('Image must smaller than 2MB!');
        }
        return isJpgOrPng && isLt2M;
    }

    function beforeUpload1(file) {
        const isSvg = file.type === 'image/svg+xml';
        if (!isSvg) {
            message.error('You can only upload JPG/PNG file!');
        }
   
        return isSvg;
    }

    function handleChange(info) {
        console.log("HANDLE CHANGE", info);
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }
        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, localImageUrl => {
                    setImageUrl(localImageUrl);
                    setLoading(false);
                }
            );
            
            setRealImageUrl(info.file.response.ImageUrl);
        }
    };

    function handleChange1(info) {
        console.log("HANDLE CHANGE", info);
        if (info.file.status === 'uploading') {
            setLoading(true);
            return;
        }
        if (info.file.status === 'done') {
            getBase64(info.file.originFileObj, localImageUrl => {
                    setSvgUrl(localImageUrl);
                    setLoading(false);
                }
            );
            
            setRealSvgUrl(info.file.response.SvgUrl);
        }
    };

    function getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    function onSelect(categoryId) {
        let category = categories.find(o => o.Id === categoryId);
        setCategoryName(category.Name);
        setCategoryId(category.Id);
    }

    const onFilterOption = (input, option) => {
        if(option.children) {
            return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0 ? true : false;
        } else if(option.label) {
            return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0 ? true : false;
        }
    }

    return (
        <Form onFinish={onFinish} form={form}>
            <div className="form form--horizontal">
                <Row gutter={16} style={{width: '100%'}}>
                    <Col span={24}>
                        <Form.Item>
                            <Select
                                showSearch
                                style={{
                                    width: 200,
                                }}
                                value={categoryName}
                                placeholder="Search Category"
                                filterOption={onFilterOption}
                                onSelect={onSelect}
                                options={newCategories}
                            />
                        </Form.Item>

                        <Form.Item name="name" label="Name"
                            rules={[
                                {
                                    required: true,
                                    message: `Name is required!`,
                                },
                            ]}>
                            <input
                                name="name"
                                type="name"
                                value={name}
                                placeholder="Name"
                                onChange={(e) => setName(e.target.value)}
                            />
                        </Form.Item>

                        <Form.Item name="image" label="Image">
                           <Upload
                                name="image"
                                listType="picture-card"
                                className="avatar-uploader"
                                showUploadList={false}
                                action={`${URL}/sticker/upload_image.php`}
                                beforeUpload={beforeUpload}
                                onChange={handleChange}
                            >
                                {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                            </Upload>
                        </Form.Item>

                        <Form.Item name="svg" label="SVG">
                           <Upload
                                name="svg"
                                listType="picture-card"
                                className="avatar-uploader"
                                showUploadList={false}
                                action={`${URL}/sticker/upload_svg.php`}
                                beforeUpload={beforeUpload1}
                                onChange={handleChange1}
                            >
                                {svgUrl ? <img src={svgUrl} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                            </Upload>
                        </Form.Item>

                        <Form.Item name="tags" label="Tags">
                            <input
                                name="tags"
                                type="tags"
                                value={tags}
                                placeholder="Tags"
                                onChange={(e) => setTags(e.target.value)}
                            />
                        </Form.Item>
                    </Col>
                </Row>
            </div>
            <Row style={{justifyContent: 'center'}}>
                <Button type="text" onClick={close}>Cancel</Button>
                <Button type="primary" htmlType="submit">{sticker ? 'Update' : 'Add'}</Button>
            </Row>
        </Form>
        
    )
}

export default ModalBody;